import { useParams, Link } from "react-router-dom";
import { PUBLIC_BASE_URL } from "../../firebase/config.js";

export default function Published() {
  const { slug } = useParams();
  const url = `${PUBLIC_BASE_URL}/${slug}`;
  return (
    <div className="container center stack" style={{ paddingTop: 96, maxWidth: 560 }}>
      <h1>🎉 You're live</h1>
      <p className="muted">Share your invite anywhere:</p>
      <div className="card row" style={{ justifyContent: "center", gap: 12 }}>
        <code style={{ fontSize: "1.1rem" }}>{url}</code>
        <button className="btn-ghost btn" onClick={() => navigator.clipboard?.writeText(url)}>Copy</button>
      </div>
      <div className="row" style={{ justifyContent: "center", gap: 12, marginTop: 12 }}>
        <a className="btn" href={url} target="_blank" rel="noreferrer">View invite</a>
        <Link className="btn-ghost btn" to={`/app/edit/${slug}`}>Keep editing</Link>
      </div>
    </div>
  );
}
